const ScormAPI = {
	TelsFlashNavigation(element: any) {
		if (element.current && element.current.contentWindow) {
			if (element.current.contentWindow.TelsFlashNavigation) {
				element.current.contentWindow.TelsFlashNavigation();
			}
		}
	},
};

export default ScormAPI;



// WEBPACK FOOTER //
// ./src/utils/ScormAPI.ts